import { Component, inject, OnInit } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { ConfigRepository } from '../../../../../../shared/repositories/config.repository';
import { BreakpointService } from '../../../../../../shared/services/breakpoint.service';
import { OutletDto } from '../../../../../../api/v1/models/outlet-dto';
import { FormSaveStrategy } from '../../../../../common/strategy/form-save-strategy/form-save-strategy.abstract';
import { Schedule } from '../../../../../../shared/interfaces/schedule.interface';
import { AddressSelectorService } from '../../../../../common/components/order-form/step-address/address-selector.service';
import { CdkFixedSizeVirtualScroll, CdkVirtualForOf, CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { FilterPipe } from '../../../../../../shared/pipes/filter/filter.pipe';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatOptionModule, MatOptionSelectionChange } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { AsyncPipe } from '@angular/common';

@UntilDestroy()
@Component({
  selector: 'app-resto-select',
  templateUrl: './resto-select.component.html',
  styleUrls: ['./resto-select.component.scss'],
  imports: [
    CdkFixedSizeVirtualScroll,
    CdkVirtualForOf,
    CdkVirtualScrollViewport,
    FilterPipe,
    FormsModule,
    MatFormFieldModule,
    MatOptionModule,
    MatSelectModule,
    NgxMatSelectSearchModule,
    ReactiveFormsModule,
    AsyncPipe,
  ]
})
export class RestoSelectComponent implements OnInit {
  private configRepository = inject(ConfigRepository);
  breakPoint = inject(BreakpointService);
  private formSaveStrategy = inject(FormSaveStrategy);
  private addressSelectorService = inject(AddressSelectorService);

  outletCtrl: FormControl<OutletDto | null> = new FormControl<OutletDto | null>(null);

  pickupAddress$ = this.configRepository.address$;

  selectedOutlet: OutletDto | null;
  selectedOutlet$: Observable<OutletDto | null> = this.addressSelectorService.selectedOutlet$.pipe(
    tap((outlet) => {
      if(!outlet) {
        return;
      }
      this.selectedOutlet = outlet;
      this.outletCtrl.setValue(outlet, {emitEvent: false});
    })
  );

  public outletsSchedule: { [key: string]: Schedule | null };
  public outletsGroup$: Observable<{ [key: string]: OutletDto[] }> = this.configRepository.sortOutletsCityMap$.pipe(
    tap((outletsGroup: { [key: string]: OutletDto[] }) => {
      this.outletsSchedule = {};
      Object.keys(outletsGroup).forEach(key => {
        outletsGroup[key].forEach((outlet: OutletDto) => {
          this.outletsSchedule[outlet.storeId] = this.configRepository.getOutletSchedule(outlet.pickupIntervals);
        });
      });
    })
  );

  ngOnInit(): void {
    this.addressSelectorService.selectedOutlet$.pipe(
      untilDestroyed(this)
    ).subscribe(outlet => {
      if(!outlet) {
        return;
      }
      this.formSaveStrategy.setActiveOutlet(outlet.storeId, true);
    });
  }

  onChangeMenu($event: MatOptionSelectionChange, outlet: OutletDto): void {
    if(!$event.isUserInput) {
      return;
    }

    if(outlet.storeId === this.selectedOutlet?.storeId) {
      return;
    }

    this.addressSelectorService.setSelectedStore(outlet);
    this.formSaveStrategy.setActiveOutlet(outlet.storeId, true);
  }

  protected readonly Object = Object;
}
